<template>
  <div>
    <el-table :data="userList" border height="calc(100vh - 300px)">
      <el-table-column prop="userId" label="用户ID">
        <template slot-scope="scope">
          <span>{{ scope.row.userId }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="登录时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="loginIp" label="登录IP">
        <template slot-scope="scope">
          <span>{{ scope.row.loginIp }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="phoneId" label="设备ID">
        <template slot-scope="scope">
          <span>{{ scope.row.phoneId }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="loginType" label="登录类型">
        <template slot-scope="scope">
          {{ scope.row.loginType }}
        </template>
      </el-table-column>
      <el-table-column
        prop="headerInfo"
        label="headerInfo"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.headerInfo }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="content"  label="验证内容" width="600px">
        <template slot-scope="scope">
          <div v-if="scope.row.type=='1'" v-html="scope.row.content"></div>
          <span v-else>{{ scope.row.content }}</span>
        </template>
      </el-table-column> -->

      <!-- <el-table-column label="编辑" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            circle
            @click="handleUpdate(scope.row)"
          ></el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>

    <!-- 编辑用户信息dialog -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'

export default {
  name: 'UserList',
  data() {
    return {
      updateForm: {},
    }
  },
  components: {
    Pagination,
  },
  methods: {
    ...mapActions('userLoginLog', [
      'updateUserType',
      'updateDividendStatus',
      'updateMark',
      'allowTrade',
      'allowTransfer',
      'allowSwitchBin',
    ]),
    ...mapMutations('userLoginLog', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
    ]),
    pageChanged(pagination) {
      this.$emit('refresh', pagination)
    },
    handleUpdate(selected) {
      this.updateForm = selected
      this.setUserinfoDetail(selected)
      this.setUserinfoDetailDialogVisible(true)
    },
  },
  computed: {
    // ...mapGetters('userLoginLog', ['userList']),
    ...mapState('userLoginLog', [
      'userList',
      'pagination',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible',
    ]),
  },
}
</script>

<style lang="less" scoped>
.user-type-select {
  width: 100%;
}
.red {
  color: skyblue;
  font-weight: bold;
}
</style>
